import React from 'react';
import BreadCrumbNav from './BreadCrumbNav';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import SpecialitiesContent from './SpecialitiesContent';
import PreLoader from './PreLoader';

const Specialities = () => {

  return (
    <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Specialities" />

        <SpecialitiesContent />

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default Specialities;